import React, { Component } from "react";
import PropTypes from "prop-types";
import Group from "./Group";
import Content from "./Content";
import Field from "./Field";
import VisibilityConditionHelper from "./VisibilityCondition";
import Form from "./Form";

export default class Part extends Component {
  constructor(props) {
    super(props);
    const { config, formik } = props;
    this.state = {
      visible: VisibilityConditionHelper.isVisible(config, formik.values),
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.formik && nextProps.formik.isValidating) {
      return false;
    }
    return true;
  }

  componentDidUpdate() {
    const { config, formik } = this.props;
    const visible = VisibilityConditionHelper.isVisible(config, formik.values);
    if (this.state.visible != visible) {
      this.setState({ visible });
      if (!visible && config.resetOnHide) {
        const parts = Form.flattenFields(config, true);
        parts.forEach((part) => {
          if (part.part === "field" && part.name) {
            formik.setFieldValue(part.name, part.value);
          }
        });
      }
    }
  }

  static propTypes = {
    config: PropTypes.object.isRequired,
    step: PropTypes.object.isRequired,
    templates: PropTypes.object,
  };

  render() {
    const { type, part } = this.props.config;
    const { config, step, formik, form } = this.props;

    if (!this.state.visible) {
      return null;
    }

    let template;
    const typeTemplateName = `${type[0].toUpperCase()}${type.substr(1)}`;
    const partTemplateName = `${part[0].toUpperCase()}${part.substr(1)}`;
    try {
      template = this.props.templates[partTemplateName][typeTemplateName];
      if (!template) throw new Error("template is undefined");
    } catch (error) {
      console.error(
        `The part ${partTemplateName} type "${typeTemplateName}" is incorrect. "Templates.${partTemplateName}.${typeTemplateName}" does not exist.`
      );
      return (
        <div style={{ color: "red", fontWeight: "bold" }}>
          Template not found:{" "}
          {`Templates.${partTemplateName}.${typeTemplateName}`}
        </div>
      );
    }

    if (part === "field")
      return (
        <Field
          template={template}
          config={config}
          step={step}
          formik={formik}
          form={form}
        />
      );
    if (part === "content")
      return (
        <Content
          template={template}
          config={config}
          step={step}
          formik={formik}
          form={form}
        />
      );
    if (part === "group")
      return (
        <Group
          template={template}
          config={config}
          step={step}
          formik={formik}
          form={form}
          templates={this.props.templates}
        />
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Part.js